import React, { FC } from 'react';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { Redirect, Route } from 'react-router';

const ContractorClientsPage: FC<any> = ({ childRoutes }): React.ReactElement => {
	return (
		<div>
			<Route
				path="/supplier/contractor_clients"
				exact={true}
				render={(props) => (
					<Redirect
						to={{
							pathname: '/supplier/contractor_clients/overview',
						}}
					/>
				)}
			/>
			{childRoutes.map((r, i) => (
				<RouteWithSubRoutes key={i} {...r} />
			))}
		</div>
	);
};

export default ContractorClientsPage;
